<template lang="html">

  <transition name="modal-fade">
    <div class="modal-background" v-show="showShareBox">

      <div id="share-box" class="container white-box" role="dialog">

        <h3 id="share-box-headline">Del {{ name }}</h3>
        <div id="share-close-btn" role="button" aria-label="Gå tilbage" @click="showShareBox = false;" tabindex="0">
          <span class="material-icons grey-text" aria-hidden="true">close</span>
        </div>

        <div class="row">

        		<div class="col-4">
              <div class="or-share-icon" role="button" id="facebook-share" aria-label="Del på Facebook" @click="shareOnFacebook()">
          			<div class="social-circle">
        					<img src="@/assets/img/fb.png" class="or-share-icon" aria-hidden="true" alt="Facebook billede">
        					<span>Facebook</span>
        				</div>
        			</div>
        		</div>

        		<div class="col-4">
        			<a class="or-share-icon" role="button" id="twitter-share" :href="'https://twitter.com/share?url=https://apps.odenserundt.dk/del/'+path" target="_blank" aria-label="Del på Twitter">
        				<div class="social-circle">
        					<img src="@/assets/img/twitter.png" class="or-share-icon" aria-hidden="true" alt="Twitter billede">
        					<span>Twitter</span>
        				</div>
        			</a>
        		</div>

        		<div class="col-4">
      				<div class="or-share-mail" role="button" aria-label="Del via mail" @click="shareByEmail();">
      					<span class="material-icons" aria-hidden="true">mail_outline</span>
      				</div>
      				<br>
      				<span aria-hidden="true">Mail</span>
        		</div>

        </div>

      </div>

    </div>
  </transition>
</template>

<script>
import { EventBus } from '@/main.js'

export default {
  data() {
    return {
      name: '',
      path: '',
      showShareBox: false,
    }
  },
  created() {
    EventBus.$on('openShareBox', (options) => {
      this.name = options.name;
      this.path = (options.type == 'place') ?'tag/'+options.tagId+'/place/'+options.id : options.type+'/'+options.id;
      this.showShareBox = true;
      this.$HelperFunctions.setScreenReaderFocus('share-box-headline');
    });
  },
  methods: {
    shareOnFacebook() {
      var that = this;
			var w = window.open('https://apps.odenserundt.dk/del/wait.html', 'Del på Facebook', 'left=40%, top=20%. width=500px, height=500px');
      var href = 'https://facebook.com/sharer.php?u=https://apps.odenserundt.dk/del/'+this.path;

      $.ajax({
        type: "POST",
        url: "https://apps.odenserundt.dk/del/scrape.php",
        data: {url: that.path},
        async: false,
        success: function(data) {
          //console.log(data);
          w.location = href;
        },
        error: function(data) {
          console.log(data);
        }
      });

			return false;
    },
    shareByEmail() {
      window.open('mailto:?subject='+this.name+' i Odense Rundt&body=https://apps.odenserundt.dk/del/'+this.path, 'shareWindow', '_blank');
    },
  }
}
</script>

<style lang="css" scoped>
#share-box {
  position: relative;
  height: auto;
  width: auto;
  padding: 15px;
  text-align: center;
}

#share-close-btn {
  position: absolute;
  height: 30px;
  top: 4px;
  right: 5px;
  cursor: pointer;
}

.or-share-icon {
	width: 60px;
  cursor: pointer;
}

.or-share-mail {
	height: 55px;
  width: 55px;
  display: inline-block;
  background-color: orange;
  border-radius: 666px;
	margin-bottom: 5px;
  cursor: pointer;
}

.or-share-mail .material-icons {
	color: white;
  font-size: 35px !important;
  position: relative;
  top: 9px;
}
</style>
